<vex-base-layout *ngIf="config$ | async as config">
  <vex-progress-bar></vex-progress-bar>
  <main>
    <router-outlet></router-outlet>
  </main>
</vex-base-layout>